"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _Select = _interopRequireDefault(require("./Select"));

var _Dropdown = _interopRequireDefault(require("./Dropdown"));

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _dropdownUtils = require("./dropdownUtils");

var _compareElementType = _interopRequireDefault(require("../helpers/compare-element-type"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_PLACEHOLDER = 'Select an option';

function discardDescription(children) {
  return _react.default.Children.map(children, function (child) {
    if (_react.default.isValidElement(child)) {
      return _react.default.cloneElement(child, {
        description: null,
        alignTop: false,
        alignVerticalCenter: false,
        alignBottom: false
      });
    }

    return child;
  });
}

function defaultValueToSelection(value, children) {
  var item = getItemByValue(children, value);
  return item ? discardDescription(item.props.children) || null : value;
}

function renderOptionGroup(child, props) {
  var item = child.props.children;
  var nextOptions;

  if (props.query) {
    nextOptions = (0, _dropdownUtils.itemMatchesQuery)(child.props.title, props.query) ? renderOptions(item, _objectSpread({}, props, {
      group: child.props.title,
      query: ''
    })) : renderOptions(item, _objectSpread({}, props, {
      group: child.props.title
    }));
  } else {
    nextOptions = renderOptions(item, _objectSpread({}, props, {
      group: child.props.title
    }));
  }

  if (nextOptions.length === 0) return;
  return _react.default.cloneElement(child, {
    children: nextOptions
  });
}

function renderOptions(children, props) {
  var onSelectItem = props.onSelectItem,
      closeMenu = props.closeMenu,
      value = props.value,
      query = props.query,
      group = props.group;

  var onItemClick = function onItemClick(child) {
    return function () {
      onSelectItem(child);
      closeMenu();
    };
  };

  return _react.default.Children.map(children, function (child) {
    if ((0, _dropdownUtils.isNotDropdownItem)(child)) return;
    if ((0, _compareElementType.default)(child, _Dropdown.default.OptionGroup)) return renderOptionGroup(child, _objectSpread({
      query: query
    }, props));
    var itemInfo = (0, _dropdownUtils.getItemInfo)(child);
    if (query && !(0, _dropdownUtils.itemMatchesQuery)(itemInfo.name || itemInfo.value, query)) return;
    return _react.default.cloneElement(child, {
      selected: value === itemInfo.value,
      group: group,
      onClick: onItemClick(child)
    });
  });
}

function getItemByValue(children, value) {
  var options = getOptions(children);
  var selectedItem = options.find(function (child) {
    if ((0, _dropdownUtils.isNotDropdownItem)(child)) return;

    if ((0, _compareElementType.default)(child, _Dropdown.default.OptionGroup)) {
      return getItemByValue(child.props.children, value);
    }

    return child.props.value === value ? child : undefined;
  });
  return selectedItem;
}

function getOptions(children) {
  return _react.default.Children.map(children, function (child) {
    if ((0, _compareElementType.default)(child, _Dropdown.default.OptionGroup)) {
      return getOptions(child.props.children);
    }

    return child;
  });
}

var DropdownStateful = function DropdownStateful(_ref) {
  var id = _ref.id,
      children = _ref.children,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? DEFAULT_PLACEHOLDER : _ref$placeholder,
      disabled = _ref.disabled,
      open = _ref.open,
      searchable = _ref.searchable,
      searchPlaceholder = _ref.searchPlaceholder,
      clearable = _ref.clearable,
      _ref$closeOnBlur = _ref.closeOnBlur,
      closeOnBlur = _ref$closeOnBlur === void 0 ? true : _ref$closeOnBlur,
      large = _ref.large,
      smallMenu = _ref.smallMenu,
      largeMenu = _ref.largeMenu,
      _ref$valueToSelection = _ref.valueToSelection,
      valueToSelection = _ref$valueToSelection === void 0 ? defaultValueToSelection : _ref$valueToSelection,
      onChange = _ref.onChange,
      onSearch = _ref.onSearch,
      onFocus = _ref.onFocus,
      noResultsMessage = _ref.noResultsMessage,
      props = _objectWithoutProperties(_ref, ["id", "children", "placeholder", "disabled", "open", "searchable", "searchPlaceholder", "clearable", "closeOnBlur", "large", "smallMenu", "largeMenu", "valueToSelection", "onChange", "onSearch", "onFocus", "noResultsMessage"]);

  var uid = id || (0, _unique.default)();

  var filteredChildren = _react.default.Children.toArray(children).filter(function (child) {
    return child;
  });

  return _react.default.createElement(_Select.default, {
    defaultOpen: open,
    defaultSelectedItems: (0, _dropdownUtils.getSelected)(filteredChildren),
    onChange: onChange,
    closeOnBlur: closeOnBlur
  }, function (_ref2) {
    var isOpen = _ref2.isOpen,
        toggleMenu = _ref2.toggleMenu,
        closeMenu = _ref2.closeMenu,
        query = _ref2.query,
        value = _ref2.value,
        onClearSelectionItems = _ref2.onClearSelectionItems,
        onSelectItem = _ref2.onSelectItem,
        onQueryChange = _ref2.onQueryChange;
    var actions = (0, _dropdownUtils.getActions)(filteredChildren);
    var renderedChildren = renderOptions(filteredChildren, {
      id: id,
      value: value,
      query: query,
      onSelectItem: onSelectItem,
      closeMenu: closeMenu
    });
    return _react.default.createElement(_Dropdown.default, _extends({
      id: uid,
      open: isOpen,
      onFocus: !isOpen ? onFocus : undefined,
      disabled: disabled,
      large: large
    }, props), _react.default.createElement(_Dropdown.default.Selection, {
      onClick: toggleMenu,
      placeholder: placeholder,
      large: large,
      onClear: clearable && value && !disabled ? onClearSelectionItems : null
    }, (0, _dropdownUtils.processSelectionChildren)(valueToSelection(value, filteredChildren))), isOpen && !disabled ? _react.default.createElement(Menu, {
      actions: actions,
      searchable: searchable,
      searchPlaceholder: searchPlaceholder,
      query: query,
      toggleMenu: toggleMenu,
      onQueryChange: onSearch || onQueryChange,
      small: smallMenu,
      large: largeMenu,
      loadMore: (0, _dropdownUtils.filterLoadMore)(filteredChildren),
      noResultsMessage: noResultsMessage
    }, renderedChildren) : null);
  });
};

var Actions = function Actions(_ref3) {
  var actions = _ref3.actions,
      toggleMenu = _ref3.toggleMenu;
  if (actions.length === 0) return null;
  var actionsList = actions.length > 0 ? (0, _dropdownUtils.processActions)(actions, toggleMenu) : null;
  return _react.default.createElement(_Dropdown.default.Actions, null, actionsList);
};

var Menu = function Menu(_ref4) {
  var children = _ref4.children,
      loadMore = _ref4.loadMore,
      searchable = _ref4.searchable,
      searchPlaceholder = _ref4.searchPlaceholder,
      query = _ref4.query,
      onQueryChange = _ref4.onQueryChange,
      noResultsMessage = _ref4.noResultsMessage,
      props = _objectWithoutProperties(_ref4, ["children", "loadMore", "searchable", "searchPlaceholder", "query", "onQueryChange", "noResultsMessage"]);

  return _react.default.createElement(_Dropdown.default.Menu, props, searchable ? _react.default.createElement(_Dropdown.default.Search, {
    searchPlaceholder: searchPlaceholder,
    query: query,
    onSearch: onQueryChange
  }) : null, _react.default.createElement(_Dropdown.default.Scrollable, null, _react.default.createElement(Actions, props), children.length > 0 ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Dropdown.default.Options, null, (0, _dropdownUtils.processOptions)(children, false)), loadMore) : _react.default.createElement(_Dropdown.default.NoResultsMessage, {
    message: noResultsMessage
  })));
};

var clearableOrBorderless = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('borderless', 'clearable');
DropdownStateful.defaultProps = {
  noResultsMessage: 'No results found'
};
DropdownStateful.propTypes = {
  id: _propTypes.string,
  children: _propTypes.any,
  placeholder: _propTypes.node,

  /** {bool}
   * Mutually exclusive props: @@borderless@@ @@clearable@@;
   * Required if @@alignRight@@, @@smallMenu@@ or @@largeMenu@@ is defined
  */
  borderless: (0, _airbnbPropTypes.and)([(0, _airbnbPropTypes.requiredBy)('alignRight', _propTypes.bool), (0, _airbnbPropTypes.requiredBy)('smallMenu', _propTypes.bool), (0, _airbnbPropTypes.requiredBy)('largeMenu', _propTypes.bool), clearableOrBorderless]),

  /** {bool} Mutually exclusive props: @@borderless@@ @@clearable@@ */
  clearable: clearableOrBorderless,
  alignRight: _propTypes.bool,
  disabled: _propTypes.bool,
  fluid: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@ */
  loading: _dropdownUtils.statusProps,

  /** {bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@ */
  checked: _dropdownUtils.statusProps,

  /** {bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@ */
  error: _dropdownUtils.statusProps,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: _dropdownUtils.sizeProps,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: _dropdownUtils.sizeProps,

  /** {bool} Mutually exclusive props: @@smallMenu@@ @@largeMenu@@ */
  smallMenu: _dropdownUtils.menuSizeProps,

  /** {bool} Mutually exclusive props: @@smallMenu@@ @@largeMenu@@ */
  largeMenu: _dropdownUtils.menuSizeProps,
  open: _propTypes.bool,
  searchable: (0, _airbnbPropTypes.requiredBy)('searchPlaceholder', _propTypes.bool),
  searchPlaceholder: _propTypes.string,
  closeOnBlur: _propTypes.bool,
  tabIndex: _propTypes.string,

  /** valueToSelection allows to pass a custom value to show in the selection when a option is clicked. */
  valueToSelection: _propTypes.func,
  onChange: _propTypes.func,
  onFocus: _propTypes.func,
  onSearch: _propTypes.func,

  /** Renders a custom message when a search returns no results. */
  noResultsMessage: _propTypes.string,
  upward: _propTypes.bool
};
DropdownStateful.Action = _Dropdown.default.Action;
DropdownStateful.Actions = _Dropdown.default.Actions;
DropdownStateful.Option = _Dropdown.default.Option;
DropdownStateful.Option.Content = _Dropdown.default.Option.Content;
DropdownStateful.Option.Description = _Dropdown.default.Option.Description;
DropdownStateful.OptionGroup = _Dropdown.default.OptionGroup;
DropdownStateful.OptionGroup.Title = _Dropdown.default.OptionGroup.Title;
DropdownStateful.LoadMore = _Dropdown.default.LoadMore;
var _default = DropdownStateful;
exports.default = _default;
DropdownStateful.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DropdownStateful",
  "props": {
    "placeholder": {
      "defaultValue": {
        "value": "'Select an option'",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "closeOnBlur": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "valueToSelection": {
      "defaultValue": {
        "value": "function defaultValueToSelection (value, children) {\n  const item = getItemByValue(children, value)\n  return item ? discardDescription(item.props.children) || null : value\n}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "valueToSelection allows to pass a custom value to show in the selection when a option is clicked."
    },
    "noResultsMessage": {
      "defaultValue": {
        "value": "'No results found'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Renders a custom message when a search returns no results."
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "borderless": {
      "type": {
        "name": "custom",
        "raw": "and([\n  requiredBy('alignRight', bool),\n  requiredBy('smallMenu', bool),\n  requiredBy('largeMenu', bool),\n  clearableOrBorderless\n])"
      },
      "required": false,
      "description": "{bool}\nMutually exclusive props: @@borderless@@ @@clearable@@;\nRequired if @@alignRight@@, @@smallMenu@@ or @@largeMenu@@ is defined"
    },
    "clearable": {
      "type": {
        "name": "custom",
        "raw": "clearableOrBorderless"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@borderless@@ @@clearable@@"
    },
    "alignRight": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "fluid": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "loading": {
      "type": {
        "name": "custom",
        "raw": "statusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@"
    },
    "checked": {
      "type": {
        "name": "custom",
        "raw": "statusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@"
    },
    "error": {
      "type": {
        "name": "custom",
        "raw": "statusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@loading@@ @@checked@@ @@error@@"
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "smallMenu": {
      "type": {
        "name": "custom",
        "raw": "menuSizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@smallMenu@@ @@largeMenu@@"
    },
    "largeMenu": {
      "type": {
        "name": "custom",
        "raw": "menuSizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@smallMenu@@ @@largeMenu@@"
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "searchable": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('searchPlaceholder', bool)"
      },
      "required": false,
      "description": ""
    },
    "searchPlaceholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "tabIndex": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onSearch": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "upward": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};